/**
 * 全局接口 code 状态码定义
 */
const CODE = {
  /** 成功 */
  OK: 0,

  /** 用户端-未登录 */
  UNAUTHORIZED: [401],
};

export default CODE;
